import type { AxiosResponse } from "axios"
import axios from "axios"

// 个人达标率分析
export interface EmployeeVO {
  // 工牌ID
  cardId: string
  // 部门
  department: string
  // 门店达标率
  storeRate: string
  // 拜访时长达标率
  stayTimeRate: string
  // 拜访频次达标率
  visitFrequencyRate: string
  // 门店平均拜访时长
  visitingTime: string
  // icon开关
  isShow?: boolean
}

/**
 * 员工数据
 */
export async function getEmployeeData() {
  try {
    const result: AxiosResponse<EmployeeVO[]> = await axios.get("/data/employee.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

// 员工步行轨迹
export interface WalkingTrailsVO {
  // 工牌ID
  id: string
  // 门店ID
  storeId: string
  // 地址
  place_name: string
  address: string
  // 省份
  province_name: string
  province_code: string
  // 城市
  city_name: string
  city_code: string
  // 区县
  district_name: string
  district_code: string
  // 街道
  township_name: string
  township_code: string
  // 纬度
  latitude: number
  // 经度
  longitude: number
  // 进入时间
  inTime: string
  // 离开时间
  outTime: string
  // 停留时间（min）
  stayTime: number
  // 拜访频次
  visitCount: number
  // 合作状态
  status: string
  // 部门
  department: string
  // CRM系统
  crm: string
}

/**
 * 员工步行轨迹数据
 */
export async function getWalkingTrails() {
  try {
    const result: AxiosResponse<WalkingTrailsVO[]> = await axios.get("/data/walking_trails.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

/**
 * 大数据中心
 */
export interface BigDataCenterVO {
  // 名称
  name: string
  // 地址
  address: string
  // 经度
  longitude: number
  // 纬度
  latitude: number
  // 省份
  provinceName: string
  provinceCode: string
  // 城市
  cityName: string
  cityCode: string
  // 区县
  districtName: string
  districtCode: string
  // 街道
  streetName: string
  streetCode: string
}

/**
 * 大数据中心数据
 */
export async function getBigDataCenter() {
  try {
    const result: AxiosResponse<BigDataCenterVO[]> = await axios.get("/data/data_center.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

/**
 * 专精特新-小巨人
 */
export interface SpecializationVO {
  // 企业id
  id: string
  // 企业名称
  name: string
  // 注册地址
  regAddress: string
  // 经营地址
  businessAddress?: string
  // 年报地址
  reportAddress: string
  // 电话
  phone: string
  // 经度
  longitude: number
  // 纬度
  latitude: number
  // 一级行业
  industryL1: string
  // 成立日期
  openingDate: string
  // 注册资本（人民币：元）
  capital: string
  // poiId
  poiId?: string
}

/**
 * 专精特新数据
 */
export async function getSpecializationData() {
  try {
    const result: AxiosResponse<SpecializationVO[]> = await axios.get("/data/specialization.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

// 门店平均拜访时长
export interface AverageTimeVO {
  // 门店编号
  storeNo: string
  // 门店名称
  storeName: string
  // 门店地址
  storeAddress: string
  // 区域
  district: string
  // 类型-1
  type1: string
  // 类型-2
  type2: string
  // 设备号
  cardId: string
  // 拜访次数
  visitCount: string
  // 拜访时间
  visitTime: string
  // 平均拜访时长
  averageTime: string
}

/**
 * 门店平均拜访时长
 */
export async function getAverageTimeData() {
  try {
    const result: AxiosResponse<AverageTimeVO[]> = await axios.get("/data/average_time.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

// 门店达标率
export interface SroteRateVO {
  // 设备号
  cardId: string
  // 部门
  department: string
  // 额定门店数
  rated: string
  // 实际门店数
  actual: string
  // 非额定门店数
  nonRated: string
  // 达标率
  successRate: string
}

/**
 * 门店达标率
 */
export async function getStoreRateData() {
  try {
    const result: AxiosResponse<SroteRateVO[]> = await axios.get("/data/store_rate.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

// 拜访时长达标率
export interface DurationRateVO {
  // 设备号
  cardId: string
  // 部门
  department: string
  // 额定门店数
  rated: string
  // 实际门店数
  actual: string
  // 总停留时间
  totalTime: string
  // 平均停留时长
  averageTime: string
  // 最大停留时长
  maxTime: string
  // 最小停留时长
  minTime: string
  // 达标率
  successRate: string
}

/**
 * 拜访时长达标率
 */
export async function getDurationRateData() {
  try {
    const result: AxiosResponse<DurationRateVO[]> = await axios.get("/data/duration_rate.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

// 拜访频次达标率
export interface FrequencyRateVO {
  // 设备号
  cardId: string
  // 额定门店数
  rated: string
  // 实际门店数
  actual: string
  // 总频次
  totalCount: string
  // 平均次数
  averageCount: string
  // 最大次数
  maxCount: string
  // 最小次数
  minCount: string
  // 达标率
  successRate: string
}

/**
 * 拜访频次达标率
 */
export async function getFrequencyRateData() {
  try {
    const result: AxiosResponse<FrequencyRateVO[]> = await axios.get("/data/frequency_rate.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

interface CityItemVO {
  id: string
  name: string
  children: CityItemVO[]
}

/**
 * 深圳城市静态数据
 */
export async function getShenzhenData() {
  try {
    const result: AxiosResponse<CityItemVO[]> = await axios.get("/data/shenzhen.json")
    return result?.data
  } catch (error) {
    throw error
  }
}

// 花木街道画像
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getHuamuProfile = async (code: number) => {
  try {
    const result: AxiosResponse<any> = await axios.get("/data/huamu_profile.json")

    return result?.data
  } catch (error) {
    throw error
  }
}

// 上海polygon
export const getShanghaiOverview = async () => {
  try {
    const result: AxiosResponse<any> = await axios.get("/shanghai/310115.json")

    return result?.data
  } catch (error) {
    throw error
  }
}

// 获取景点数据
export const getScenicSpotIcons = async () => {
  try {
    const result: AxiosResponse<any> = await axios.get("/data/scenics_pot_icons.json")

    return result?.data
  } catch (error) {
    throw error
  }
}
